import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-2e184ae0")

_pushScopeId("data-v-2e184ae0")
const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "text-red-lp-100" }
const _hoisted_3 = {
  class: "absolute inset-y-0 right-0 flex items-center px-2",
  style: {"cursor":"pointer"}
}
const _hoisted_4 = {
  class: 
        `select w-full bg-white absolute border border-t-0 border-gray-lp-400 rounded-b-md px-4 z-50 overflow-x-show`
      ,
  style: {"max-height":"80vh"}
}
const _hoisted_5 = { class: " text-red-lp-100 absolute top-0 right-0 mt-2 mr-2" }
const _hoisted_6 = { class: "px-1 py-4 border-b border-gray-lp-400" }
const _hoisted_7 = { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-4" }
const _hoisted_8 = {
  key: 1,
  class: "px-1 py-4 border-b border-gray-lp-400"
}
const _hoisted_9 = { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-4" }
const _hoisted_10 = {
  key: 2,
  class: "px-1 py-4 border-b border-gray-lp-400"
}
const _hoisted_11 = { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-4" }
const _hoisted_12 = {
  key: 3,
  class: "px-1 py-4 border-b border-gray-lp-400"
}
const _hoisted_13 = { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-4" }
const _hoisted_14 = { class: "px-1 py-4 border-b border-gray-lp-400" }
const _hoisted_15 = { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px mb-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Select = _resolveComponent("Select")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", {
    class: 
      `advanced-filter inline-block relative width-advance-filter bottom-0 left-0 text-12px xxl:text-14px mr-2 ${_ctx.openFilter &&
        'w-300px'}`
    
  }, [
    _createVNode("div", {
      class: 
        `bg-white ${
          _ctx.openFilter && !_ctx.isDisabled ? 'rounded-t' : 'rounded'
        } border text-black-lp-300 leading-tight px-3 py-2.5 xxl:py-2.5 pr-8 font-normal`
      ,
      style: {"cursor":"pointer"},
      onClick: _cache[2] || (_cache[2] = 
        () => {
          _ctx.openFilter = !_ctx.openFilter;
          _ctx.$emit('opened', _ctx.openFilter);
        }
      )
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", {
          class: _ctx.isDisabled && 'opacity-50'
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("userManagement.list.filter.filter")) + " ", 1),
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.sumFilter !== 0 ? `(${_ctx.sumFilter})` : ""), 1)
        ], 2)
      ]),
      _createVNode("div", _hoisted_3, [
        (_ctx.openFilter)
          ? (_openBlock(), _createBlock("img", {
              key: 0,
              src: _imports_0,
              class: `w-4  ${_ctx.sumFilter > 0 ? 'arrow-red' : ''}`,
              alt: "up"
            }, null, 2))
          : (_openBlock(), _createBlock("img", {
              key: 1,
              src: _imports_1,
              class: `w-4  ${_ctx.sumFilter > 0 ? 'arrow-red' : ''}`,
              onClick: _cache[1] || (_cache[1] = 
            () => {
              _ctx.isChevron = true;
            }
          ),
              alt: "down"
            }, null, 2))
      ])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_4, [
      (_ctx.sumFilter > 0)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args))),
            class: "relative cursor-pointer w-full mb-4"
          }, [
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("userManagement.list.filter.reset")), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("userManagement.list.filter.accountType")), 1),
        _createVNode(_component_Select, {
          class: "w-full",
          dataSelect: _ctx.typeData,
          onOpenSelect: _ctx.onOpenTypeSelect,
          onCloseSelect: _ctx.onCloseTypeSelect,
          onChooseSelect: _ctx.onSelectType,
          value: _ctx.typeValue,
          isOpenMenu: _ctx.typeSelect
        }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
      ]),
      (!_ctx.typeValue.match(/^internal$|^customer-service$/))
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("userManagement.list.filter.reference")), 1),
            _createVNode(_component_SelectSearch, {
              onFilter: _ctx.fetchListReference,
              onFocus: _ctx.focusListReference,
              isLoading: _ctx.loadingReference,
              options: _ctx.referenceDataList,
              keyName: "name",
              keyValue: "value",
              placeholder: _ctx.$t('userManagement.list.filter.selectReference'),
              "model-value": _ctx.referenceModelValue,
              "onUpdate:modelValue": _ctx.onSelectReference
            }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "model-value", "onUpdate:modelValue"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.showHub)
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("userManagement.list.filter.hub")), 1),
            _createVNode(_component_SelectSearch, {
              class: [
            {
              'disabled-hub-field': _ctx.isReferenceEmptyHub
            }
          ],
              isLoading: _ctx.loadingHub,
              options: _ctx.listHubDataList,
              keyName: "name",
              keyValue: "value",
              placeholder: _ctx.$t('userManagement.list.filter.selectHub'),
              "model-value": _ctx.hubName,
              useInfiniteScroll: "",
              "onUpdate:modelValue": _ctx.onSelectHub,
              "is-disabled": _ctx.typeValue === '' || _ctx.isReferenceEmptyHub,
              onScrolled: _ctx.fetchListHubInfiniteScroll
            }, null, 8, ["class", "isLoading", "options", "placeholder", "model-value", "onUpdate:modelValue", "is-disabled", "onScrolled"])
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.roleAccount === 'internal' &&
            (_ctx.typeValue === 'internal' || _ctx.typeValue === '')
        )
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("userManagement.list.filter.division")), 1),
            _createVNode(_component_SelectSearch, {
              onFilter: _ctx.fetchListDivision,
              onFocus: _ctx.focusListDivision,
              isLoading: _ctx.loadingDivision,
              options: _ctx.divisionDataList,
              keyName: "name",
              keyValue: "value",
              placeholder: _ctx.$t('userManagement.list.filter.selectDivision'),
              "model-value": _ctx.divisionName,
              "onUpdate:modelValue": _ctx.onSelectDivision
            }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "placeholder", "model-value", "onUpdate:modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_14, [
        _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("userManagement.list.filter.status")), 1),
        _createVNode(_component_Select, {
          class: "w-full",
          dataSelect: _ctx.statusData,
          onOpenSelect: _ctx.onOpenStatusSelect,
          onCloseSelect: _ctx.onCloseStatusSelect,
          onChooseSelect: _ctx.onSelectStatus,
          value: _ctx.status,
          isOpenMenu: _ctx.statusSelect
        }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
      ])
    ], 512), [
      [_vShow, _ctx.openFilter && !_ctx.isDisabled]
    ])
  ], 2)), [
    [_directive_click_outside, 
      () => {
        if (_ctx.isChevron) {
          _ctx.openFilter = true;
          _ctx.$emit('opened', true);
          _ctx.isChevron = false;
        } else if (_ctx.openFilter) {
          _ctx.$emit('opened', false);
          _ctx.openFilter = false;
        }
      }
    ]
  ])
})